import { render, staticRenderFns } from "./LicenceKey.vue?vue&type=template&id=20729dc5&scoped=true&"
import script from "./LicenceKey.vue?vue&type=script&lang=js&"
export * from "./LicenceKey.vue?vue&type=script&lang=js&"
import style0 from "./LicenceKey.vue?vue&type=style&index=0&id=20729dc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20729dc5",
  null
  
)

export default component.exports